<template>
	<div class="hello">
		<div class="detailList" ref="details">
			<div class="detailTop">
				<div class="detailLeft">
					<div class="leftTop">
						<img :src="cover_img" alt="">
					</div>
					<div class="leftBottom">
						<swiper class="swiper" :options="swiperOptionO" ref="Swiper">
							<swiper-slide v-for="(item,index) in nextImage" :key="index"
								class="swiper-slides swiper-slide " @click.native="imageEvent(index)">
								<img :class="{is:item.isActive}" width="70px" height="70px" :src="item.image" alt="">
							</swiper-slide>

						</swiper>
						<div class="swp1">
							<img src="../assets/image/sliderLeft.png" alt="">
						</div>
						<div class="swp2">
							<img src="../assets/image/sliderRight.png" alt="">
						</div>
					</div>
				</div>

				<div class="detailRight">
					<div class="biaoti">
						<span>{{detail.title}}</span>
					</div>
					<div class="tia" :title="detail.goods_desc">
						<span>{{detail.goods_desc}}</span>
					</div>
					<div class="price">
						<span>￥{{spec_price}}</span>
						<span class="sp">运费: {{ fee_price }} {{min_change}} </span>
					</div>
					<div class="taocan">
						<span>套餐</span>
					</div>
					<div class="select">
						<div class="meal" :class="{meal_active : item.isActive}" v-for="(item,index) in specList"
							:key="index" @click="sepcEvent(index)">
							<span>{{item.spec_name}}</span>
						</div>

					</div>
					<div class="number">
						<span>数量</span>
					</div>
					<div class="addE">
						<div class="reduce" @click="reduceEvent()">
							<img src="../assets/image/reduce.png" alt="">
						</div>
						<div class="nu">
							{{number}}
						</div>
						<div class="add" @click="addEvent()">
							<img src="../assets/image/addr.png" alt="">
						</div>
					</div>
					<div class="submitBtn">
						<div class="btn" @click="submit()">
							立即购买
						</div>
						<div class="btn cars" @click="addCar()">
							加入购物车
						</div>
					</div>
				</div>
			</div>
			<div class="detailsa" v-html="detail.detail"></div>
			<div class="clear"></div>
			<fiex :shows="fixed" :fatherMethod="goTop" ref="fiex"></fiex>
			<div style="height: 300px;"></div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import fiex from '../components/fiex.vue'
	export default {
		components: {
			fiex
		},
		data() {
			return {
				fixed: true,
				spec_price: 0,
				cover_img: '',
				number: 1,
				spec_id: 0,
				swiperOptionO: {
					slidesPerView: 4,
					spaceBetween: 10,
					//设置点击箭头
					navigation: {
						nextEl: '.swp2',
						prevEl: '.swp1',
					},
					observer: true, //修改swiper自己或子元素时，自动初始化swiper
					observeParents: true, //修改swiper的父元素时，自动初始化swiper
					//自动轮播
					loop: false,
				},
				specList: [],
				nextImage: [{
						image: require('../assets/image/book.jpg')
					},
					{
						image: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1597897313521&di=575159edd472012316125f96a2f08eaa&imgtype=0&src=http%3A%2F%2F00.minipic.eastday.com%2F20170331%2F20170331113141_98c8105e504ff71e68d59a6eaa30bd7e_5.jpeg'
					},
					{
						image: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1697850329,1416483110&fm=26&gp=0.jpg'
					},
					{
						image: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1597897345001&di=5f05090c45038d14bf05b562879a2370&imgtype=0&src=http%3A%2F%2F01.minipic.eastday.com%2F20170509%2F20170509175335_e125fe24122d6da4333be87d6aa5a190_7.jpeg'
					}
				],
				detail: {},
				spec_id: 0,
				category_id: 0,
				fee_price: 0,
				min_change: ''
			}
		},
		created() {
			var data = {
				id: this.$route.query.id
			}
			this.$fetch('goods/detail', data).then(res => {
				if (res.code == 200) {
					this.detail = res.data;
					// this.nextImage = res.picarr;
					var arr = [];
					res.data.picarr.forEach(item => {
						var obj = {};
						obj.image = item;
						arr.push(obj);
					})
					arr.forEach(item => {
						this.$set(item, 'isActive', false);
					})
					this.nextImage = arr;

					this.nextImage[0].isActive = true;
					res.data.spec.forEach(item => {
						this.$set(item, 'isActive', false);
					})
					this.specList = res.data.spec;
					this.specList[0].isActive = true;
					this.spec_id = this.specList[0].spec_id;
					this.cover_img = this.specList[0].pic;
					this.spec_price = this.specList[0].price;
					this.$fetch('goods/categoryDetail', {
						id: res.data.category_id
					}).then(res => {
						if (res.code == 200) {
							if (res.data.fee_price != -0) {
								this.fee_price = '￥' + res.data.fee_price
								if (parseFloat(res.data.min_charge) >= 10000) {
									this.min_change = '';
								} else {
									this.min_change = '(满' + '￥' + res.data.min_charge + '免运费)';
								}
							} else {
								this.fee_price = '免运费'
							}
						}
					})
				}


			})


		},
		methods: {
			goTop() {
				this.$refs.details.scrollTop = 0;
			},
			sepcEvent(index) {
				var that = this;
				this.specList.map(item => {
					this.$set(item, 'isActive', false);
				})
				this.$set(this.specList[index], 'isActive', !this.specList[index].isActive)
				this.cover_img = this.specList[index].pic;
				this.spec_id = this.specList[index].spec_id;
				console.log(this.specList[index])
				this.spec_price = this.specList[index].price;
			},
			imageEvent(index) {
				this.nextImage.map(item => {
					this.$set(item, 'isActive', false);
				})
				this.$set(this.nextImage[index], 'isActive', true);
				this.cover_img = this.nextImage[index].image;
			},
			submit() {
				console.log(this.detail);
				
				var carArr = [{
					goods_id: this.detail.goods_id,
					goods_num: this.number,
					spec_id: this.spec_id
				}]
				localStorage.setItem('carArr', JSON.stringify(carArr));
				if(localStorage.getItem('access_token')){
					this.$router.push({
						path: '/information',
						query: {
							isCar: 0
						}
					})
				}else{
					this.$message.error(this.$t('language.onLogin'))
				}
			},
			addEvent() {
				this.number += 1;
			},
			goTop() {
				this.$refs.details.scrollTop = 0;
			},
			reduceEvent() {
				this.number -= 1;
				if (this.number <= 0) {
					this.number = 1;
				}
			},
			addCar() {
				if(!localStorage.getItem('access_token')){
					this.$message.error(this.$t('language.onLogin'))
					return 
				}
				var that = this;

				var data = {
					goods_id: this.detail.goods_id,
					spec_id: this.spec_id,
					goods_num: this.number
				}
				this.$post('cart/add', data).then(res => {
					if (res) {
						this.$message.success('添加成功')
						that.$refs.fiex.ajaxFunc();
					}
				})

			}
		}
	}
</script>

<style scoped="scoped">
	@import url("../assets/css/detail.css");
</style>



// WEBPACK FOOTER //
// src/pages/detail.vue